import React, { Component } from 'react';
import Webcam from 'react-webcam';
import { Modal, Button, Container, Row, Col } from "react-bootstrap";

class VideoConsent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recording: false,
            videoBlob: null,
            previewUrl: null,
        };

        this.webcamRef = React.createRef();
        this.mediaRecorder = null;
        this.chunks = [];
    }

    startRecording = () => {
        const stream = this.webcamRef.current.stream;
        this.mediaRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
        this.chunks = [];

        this.mediaRecorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
                this.chunks.push(e.data);
            }
        };

        this.mediaRecorder.onstop = this.handleRecordingStop;

        this.mediaRecorder.start();
        this.setState({ recording: true });
    };

    stopRecording = () => {
        if (this.mediaRecorder) {
            this.mediaRecorder.stop();
        }
    };

    handleRecordingStop = () => {
        const videoBlob = new Blob(this.chunks, { type: "video/webm" });
        const previewUrl = URL.createObjectURL(videoBlob);

        this.setState({
            recording: false,
            videoBlob,
            previewUrl,
        });
    };

    saveVideo = () => {
        const { videoBlob } = this.state;

        if (videoBlob) {
            const { patientId, treatmentPlanIdTmt, chemoScheduleId, firstName, lastName } = this.props;
            // Consent is per treatment day, so the day has to be in the filename —
            // without it every day of a plan produces an identical file.
            const daySuffix = chemoScheduleId ? `Day:${chemoScheduleId}` : '';
            const fileName = `VideoConsent+${firstName} ${lastName}+id:${patientId}TmtId:${treatmentPlanIdTmt}${daySuffix}.webm`;

            // Create a download link and click it to save the video
            const link = document.createElement('a');
            link.href = URL.createObjectURL(videoBlob);
            link.download = fileName;
            document.body.appendChild(link); // Append to the DOM
            link.click(); // Trigger the download
            document.body.removeChild(link); // Remove it after the click

            // Simulate the file input change event to auto-select the video file
            const videoFile = new File([videoBlob], fileName, { type: "video/webm" });
            this.props.onSelectVideo(videoFile);

            // Automatically close the video consent modal
            this.props.onClose();
        }
    };

    discardVideo = () => {
        this.setState({
            videoBlob: null,
            previewUrl: null,
        });
    };

    render() {
        const { recording, previewUrl } = this.state;
        return (
            <Modal show={true} onHide={this.props.onClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Record Video Consent</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <Row className="justify-content-center">
                            <Col lg="12" className="text-center">
                                {!previewUrl ? (
                                    <Webcam
                                        audio={true}
                                        ref={this.webcamRef}
                                        screenshotFormat="image/jpeg"
                                        width="100%"
                                        videoConstraints={{
                                            width: 640,
                                            height: 360,
                                            facingMode: "user",
                                        }}
                                        style={{
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            border: '2px solid #007bff'
                                        }}
                                    />
                                ) : (
                                    <video
                                        controls
                                        src={previewUrl}
                                        width="100%"
                                        style={{
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                            border: '2px solid #28a745'
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant={recording ? "danger" : "primary"}
                        onClick={recording ? this.stopRecording : this.startRecording}
                        disabled={!!previewUrl}
                    >
                        {recording ? "Stop Recording" : "Start Recording"}
                    </Button>
                    {previewUrl && (
                        <>
                            <Button variant="success" onClick={this.saveVideo}>
                                Save
                            </Button>
                            <Button variant="warning" onClick={this.discardVideo}>
                                Discard
                            </Button>
                        </>
                    )}
                    <Button variant="outline-secondary" onClick={this.props.onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default VideoConsent;
